import React, { useState, useEffect } from 'react'
import { Form, Input, Button, Checkbox, Select, Divider, Row, Col } from 'antd';
import { RegisterContainer,FlexContainer } from './style';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {GetRegister,checkEmail} from '../../actions/auth'
const { Option } = Select;
const Registration = ({GetRegister,checkEmail}) => {
    const [clientType, setClientType] = useState(null)
    const [isUnique, setIsUnique] = useState(true)
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const onFinish = (values) => {
        GetRegister(values)
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
      const handleEmailCheck = async (e) => {
          const res = await checkEmail(e.target.value)
          console.log(res)
          setIsUnique(res)
      }
    return ( 
        <FlexContainer>
            <RegisterContainer>
                    <img src='./logo.png' />

                    <Form
                    name="basic"
                    labelCol={{
                        span: 24,
                    }}
                    wrapperCol={{
                        span: 24,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    style={{width: '100%'}}
                    requiredMark={false}
                    >
                        <br />
                        <br />
                        <Row>
                            <Col sm={24}>
                            <Divider>Basic Information</Divider></Col>
                            <Col sm={24}>
                                
                                <Row  gutter={16}>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="First Name"
                                            name="first_name"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your first name!',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                    <Form.Item
                                        label="Last Name"
                                        name="last_name"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Please input your last name!',
                                        },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                </Row>
                            </Col>

                            <Col sm={24}>
                                <Row gutter={16}>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Mobile Number"
                                            name="mobile_number"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your mobile number!',
                                            },
                                            {
                                                pattern: new RegExp(/^(01)[0-9][0-9]{8}$/),
                                                message: 'Please enter a valid mobile number'
                                            }
                                            ]}
                                        >
                                            <Input prefix="+88 " />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label={(isUnique || isUnique === undefined) ? "Email" :<span style={{color: '#ED1C24'}}>Email already in use</span> }
                                            name="email"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your email',
                                            },
                                            {
                                                pattern: new RegExp(/\S+@\S+\.\S+/),
                                                message: 'Please enter a valid email'
                                            }
                                            ]}
                                        >
                                            <Input 
                                            type="email" onChange={(e) => handleEmailCheck(e)}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            
                            <Col sm={24}>
                                <Row gutter={16}>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Brand Name"
                                            name="brand_name"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your Brand name!',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                            <Form.Item
                                                label="User type"
                                                name="client_type"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your user type',
                                                },
                                                ]}
                                            >
                                                <Select  style={{ width: '100%' }} onChange={(e)=> setClientType(e)}>
                                                <Option value="individual">Person</Option>
                                                <Option value="company">Company</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                </Row>
                            </Col>

                            {clientType === 'company' ? 
                            <Col sm={24}> 
                                <Row gutter={16}>
                                    <Col sm={24}>
                                            <Divider>Company Information</Divider>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Company Name"
                                            name="company_name"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your name',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Mobile Number"
                                            name="company_mobile_number"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input company mobile number',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Company Email"
                                            name="company_email"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input company email',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Company Street Address"
                                            name="street_address"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input street address',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Post Code"
                                            name="post_code"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input company post code',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="City"
                                            name="city"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input company city',
                                            },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            :null}

                             
                            <Col sm={24}> 
                                <Row gutter={16}>
                                    
                                    <Col sm={24}>
                                        <Divider>Password Setting</Divider>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Password"
                                            name="password"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your password!',
                                            },
                                            ]}
                                        >
                                            <Input.Password />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Item
                                            label="Confirm Password"
                                            name="confirm_password"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your password!',
                                            },
                                            ]}
                                        >
                                            <Input.Password />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>

                            <Col sm={24}>
                                <Form.Item name="news_letter" valuePropName="checked" wrapperCol={{ offset: 1, span: 23 }}>
                                    <Checkbox>Subscribe newsletter</Checkbox>
                                </Form.Item>
                                <Form.Item name="tc" valuePropName="checked" wrapperCol={{ offset: 1, span: 23 }} rules={[
                                    {
                                        required: true,
                                        message: 'Without accepting the terms and condition you can not register',
                                    },
                                    ]}>
                                    <Checkbox>I accept the <Link to="./terms_and_conditions_fakeBuzz.docx" target="_blank" download="term_and_conditions_fakebuzz">terms and conditions</Link></Checkbox>
                                </Form.Item>
                            </Col>
                   

                            
                        </Row>
                    
                    


                    <Form.Item
                    style={{textAlign: 'center'}}
                    >
                        {isUnique === false ?
                        <Button type="primary" htmlType="submit" disabled> Register </Button>
                        :
                        <Button type="primary" htmlType="submit" > Register </Button>
                        }
                    </Form.Item>
                    <p>Already have an account?<Link to="/login"> Login</Link></p>
                    </Form>
            </RegisterContainer>
        </FlexContainer>
     );
}
 
export default connect(null,{GetRegister,checkEmail})(Registration);